// NGXS actions must stay newable classes: withActions/createDispatchMap in
// @res/ngg-core is typed over ActionDef, which requires a `new (...args)`
// signature, and the dispatcher matches action results by reference identity.
// The parameterless ones therefore carry a mirror instance field so they are
// not classes of statics only. NGXS resolves the type from constructor.type
// first, so the dispatched string is unchanged.
import { ColumnState, FilterModel } from 'ag-grid-community';

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace PersonalPreferencesActions {
  export class GetAllPreferencesFromLocalStore {
    static readonly type = '[PersonalPreferences] GetAllPreferencesFromLocalStore';
    readonly type = GetAllPreferencesFromLocalStore.type;
  }

  export class SaveGridPaginationPageSize {
    static readonly type = '[PersonalPreferences] SaveGridPaginationPageSize';
    constructor(public pageSize?: number) {}
  }

  export class SaveGridFilter {
    static readonly type = '[PersonalPreferences] SaveGridFilter';
    constructor(
      public gridName: string,
      public gridFilter?: FilterModel,
    ) {}
  }

  export class SaveGridSort {
    static readonly type = '[PersonalPreferences] SaveGridSort';
    constructor(
      public gridName: string,
      public gridSort?: ColumnState[],
    ) {}
  }

  export class PersonalPreferencesError {
    static readonly type = '[PersonalPreferences] PersonalPreferencesError';

    constructor(public error: Error) {}
  }
}
